import PipelinesAPI from '../../api/saas/pipelines';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getPipelines($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit }) {
    commit('SET_PIPELINES_UI_FLAG', { isFetching: true });
    try {
      const response = await PipelinesAPI.get();
      commit('SET_PIPELINES', response.data);
    } catch (error) {
      // Ignore
    } finally {
      commit('SET_PIPELINES_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, data) {
    commit('SET_PIPELINES_UI_FLAG', { isCreating: true });
    try {
      const response = await PipelinesAPI.create(data);
      commit('ADD_PIPELINE', response.data);
      return response.data;
    } finally {
      commit('SET_PIPELINES_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...data }) {
    commit('SET_PIPELINES_UI_FLAG', { isUpdating: true });
    try {
      const response = await PipelinesAPI.update(id, data);
      commit('UPDATE_PIPELINE', response.data);
      return response.data;
    } finally {
      commit('SET_PIPELINES_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_PIPELINES_UI_FLAG', { isDeleting: true });
    try {
      await PipelinesAPI.delete(id);
      commit('DELETE_PIPELINE', id);
    } finally {
      commit('SET_PIPELINES_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_PIPELINES_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_PIPELINES($state, data) {
    $state.records = data;
  },
  ADD_PIPELINE($state, data) {
    $state.records.push(data);
  },
  UPDATE_PIPELINE($state, data) {
    const idx = $state.records.findIndex(s => s.id === data.id);
    if (idx !== -1) {
      $state.records.splice(idx, 1, data);
    }
  },
  DELETE_PIPELINE($state, id) {
    $state.records = $state.records.filter(s => s.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
